import { Playlist } from "../Models/Playlist";
import { FileDataset, FilePack, ObjectDataset, OnlineStorage } from "@tblabs/storage";
import { Song } from "../Models/Song";
import { Collection } from "@tblabs/truffle";
import { FileUtils } from "./FileUtils";
import { PlaylistConverter } from "./PlaylistConverter";


export class PlaylistProvider
{
    public Songs = new Collection<Song>();
    public Playlists = new Collection<Playlist>();

    private songsDataset: FileDataset;
    private playlistsDataset!: ObjectDataset<Playlist>;


    constructor(private _storage: OnlineStorage)
    {
        this.songsDataset = this._storage.GetFileDataset("Songs");
    }

    public async Init(): Promise<void>
    {
        const songs = (await this.GetAllAvailableSongs()).Items;
        this.Songs.Load(...songs);
        const playlists = (await this.GetAvailablePlaylists()).Items;
        this.Playlists.Load(...playlists);
    }

    public async AddSongs(files: File[]): Promise<Song[]>
    {
        const addedFiles: FilePack[] = await this.songsDataset.Add(files);
        const songs = addedFiles.map(this.FileToSong);
        this.Songs.Add(...songs);
        return songs;
    }

    private FileToSong(file: FilePack): Song
    {
        return new Song(file.Id, FileUtils.GetFileNameWithoutExtension(file.OriginalName), file.Url);
    }

    public async GetAllAvailableSongs(): Promise<Collection<Song>> 
    {
        const files: FilePack[] = await this.songsDataset.GetAll();
        const songs = files.map(this.FileToSong);
        return new Collection<Song>(songs);
    }

    public async GetAvailablePlaylists(): Promise<Collection<Playlist>>
    {
        const _playlistConverter = new PlaylistConverter(this.Songs.Items);
        this.playlistsDataset = this._storage.GetObjectDataset<Playlist>("Playlists", _playlistConverter);
        return new Collection<Playlist>(await this.playlistsDataset.GetAll());
    }

    public async UpdatePlaylist(playlist: Playlist): Promise<void>
    {
        await this.playlistsDataset.Update(playlist.Id, playlist);
        this.Playlists.ForceOnChange();
    }

    public async AddPlaylist(playlist: Playlist): Promise<void>
    {
        await this.playlistsDataset.Add(playlist.Id, playlist);
        this.Playlists.Add(playlist);
    }
}
